// extracted by mini-css-extract-plugin
export default {"emptyState":"EmptyState_emptyState__Y2QmW","heading":"EmptyState_heading__4sE2l","text":"EmptyState_text__tBZmV"};